import {
  Action_SaveKho,
  Action_SaveKhoSuccess,
  Action_SaveKhoFailed,
  Action_GetDanhSachKho,
  Action_GetDanhSachKhoSuccess,
  Action_GetChiTietKho,
  Action_GetChiTietKhoSuccess,
  Action_DeleteKho,
  Action_DeleteKhoSuccess,
  Action_DeleteKhoFailed,
  Action_LockUnlock,
  Action_LockUnlockSuccess,
  Action_LockUnlockFailed,
} from "actions/Kho/actionTypes";

const initialState = {
  isSaveOk: false,
  isDeleteOk: false,
  isLockUnlockOk: false,
  objData: {},
  listKho: [],
  objKhoEdit: null,
  isStartProcess: false,
};

const Reducer_SaveKho = (state, action) => ({
  ...state,
  objData: action.payload,
  isStartProcess: true,
});
const Reducer_SaveKhoSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    isSaveOk: true,
    objData: action.payload,
    isStartProcess: false,
  };
};
const Reducer_SaveKhoFalse = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    isSaveOk: false,
    isStartProcess: false,
  };
};

const Reducer_GetDanhSachKho = (state, action) => ({
  ...state,
  isStartProcess: true,
});
const Reducer_GetDanhSachKhoSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    listKho: action.payload,
    isStartProcess: false,
  };
};

const Reducer_GetChiTietKho = (state, action) => ({
  ...state,
  objKhoEdit: null,
  isStartProcess: true,
});
const Reducer_GetChiTietKhoSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objKhoEdit: action.payload,
    isStartProcess: false,
  };
};

const Reducer_DeleteKho = (state, action) => ({
  ...state,
  objData: action.payload,
  isStartProcess: true,
});
const Reducer_DeleteKhoSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    isDeleteOk: true,
    isStartProcess: false,
  };
};
const Reducer_DeleteKhoFalse = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    isDeleteOk: false,
    isStartProcess: false,
  };
};

const Reducer_LockUnlockKho = (state, action) => ({
  ...state,
  objData: action.payload,
  isStartProcess: true,
});
const Reducer_LockUnlockKhoSuccess = (state, action) => {
  return {
    ...state,
    isLockUnlockOk: true,
    isStartProcess: false,
  };
};
const Reducer_LockUnlockKhoFalse = (state, action) => {
  return {
    ...state,
    isLockUnlockOk: false,
    isStartProcess: false,
  };
};

// end
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case Action_SaveKho:
      return Reducer_SaveKho(state, action);
    case Action_SaveKhoSuccess:
      return Reducer_SaveKhoSuccess(state, action);
    case Action_SaveKhoFailed:
      return Reducer_SaveKhoFalse(state, action);
    case Action_GetDanhSachKho:
      return Reducer_GetDanhSachKho(state, action);
    case Action_GetDanhSachKhoSuccess:
      return Reducer_GetDanhSachKhoSuccess(state, action);
    case Action_GetChiTietKho:
      return Reducer_GetChiTietKho(state, action);
    case Action_GetChiTietKhoSuccess:
      return Reducer_GetChiTietKhoSuccess(state, action);
    case Action_DeleteKho:
      return Reducer_DeleteKho(state, action);
    case Action_DeleteKhoSuccess:
      return Reducer_DeleteKhoSuccess(state, action);
    case Action_DeleteKhoFailed:
      return Reducer_DeleteKhoFalse(state, action);
    case Action_LockUnlock:
      return Reducer_LockUnlockKho(state, action);
    case Action_LockUnlockSuccess:
      return Reducer_LockUnlockKhoSuccess(state, action);
    case Action_LockUnlockFailed:
      return Reducer_LockUnlockKhoFalse(state, action);

    default:
      return state;
  }
};
export default authReducer;
